import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Trust from './pages/Trust';

const App: React.FC = () => {
  const scrollToWaitlist = (e: React.MouseEvent) => {
    e.preventDefault();
    const waitlistSection = document.getElementById('signup');
    waitlistSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Router>
      <div className="flex min-h-screen flex-col bg-background">
        <Navigation onScrollToWaitlist={scrollToWaitlist} />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/trust" element={<Trust />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
